import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { cloneDeep } from 'lodash-es';
import { Subscription } from 'rxjs';
import { ConfigurationStatus, ConfigurationType } from '../../../../domain/consts';
import { ValidationError } from '../../../../domain/error.model';
import { Offer } from '../../../../domain/offer.domain';
import { EntityRole, SystemUser } from '../../../../domain/user.model';
import { ErrorAwareComponent, LsnErrorStateMatcher } from '../../../shared/middleware/error-state-matcher';
import { DialogAction } from '../../store/dialog.action';
import { ErrorsState } from '../../store/errors.state';
import { FrontierAction } from '../../store/frontier.action';
import { FrontierState } from '../../store/frontier.state';
import { UserState } from '../../store/user.state';

@Component({
    selector: 'app-frontier-summary',
    templateUrl: './frontier-summary.component.html',
    styleUrls: ['./frontier-summary.component.scss']
})
export class FrontierSummaryComponent implements OnInit, OnDestroy, ErrorAwareComponent {
    offer: Offer = null;

    errors: ValidationError[] = [];
    subscriptions: Subscription[] = [];
    matchers = {
        location: new LsnErrorStateMatcher(this, 'additionalData.location'),
        premium: new LsnErrorStateMatcher(this, 'offer.premium'),
        generic: new LsnErrorStateMatcher(this, null),
    };
    user: SystemUser;
    configurationTypes = ConfigurationType;

    get readonly(): boolean {
        return !this.isSeller;
    }

    get isSeller(): boolean {
        return [EntityRole.WORKER, EntityRole.AGENT, EntityRole.DIRECT_SALES].indexOf(this.user.entityRole) !== -1;
    }

    get hasFinishedProducts(): boolean {
        return this.offer.premium !== null &&
            this.offer.productList
                .filter(p => p.configuration.configurationStatus === ConfigurationStatus.COMPLETED)
                .length > 0;
    }

    constructor(private store: Store) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.store.select(FrontierState.getOffer).subscribe(offer => this.offer = cloneDeep(offer)),
            this.store.select(ErrorsState.getMainErrors).subscribe(errors => this.errors = errors),
            this.store.select(UserState.getUser).subscribe(user => this.user = user),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    issue() {
        const {clauseMap} = this.offer.additionalData;
        this.store.dispatch(new FrontierAction.Issue(this.offer.id, {clauseMap}));
    }
}
